import dateformat from 'dateformat';

import EpisodePageViewAggregationMapper, {
  EpisodePageViewAggregationData,
} from '../../../value_objects/mappers/summary/EpisodePageViewAggregationMapper';

import TapNovelRestApi from '../../../data_stores/net/TapNovelRestApi';

import EpisodePageViewAggregationsRepository from '../../../../domain/repositories/writer/summary/EpisodePageViewAggregationsRepository';
import EpisodePageViewAggregation from '../../../../domain/value_objects/summary/EpisodePageViewAggregation';

export default class NetEpisodePageViewAggregationsRepository
  implements EpisodePageViewAggregationsRepository
{
  private mapper: EpisodePageViewAggregationMapper;
  constructor() {
    this.mapper = new EpisodePageViewAggregationMapper();
  }

  public async findBy(params: {
    storyId: number;
    from?: Date;
    to?: Date;
  }): Promise<Array<EpisodePageViewAggregation>> {
    const path = `/api/writer/summary/episode_page_view_aggregations${this.generateQuery(
      params,
    )}`;
    const obj = await TapNovelRestApi.get<
      Array<EpisodePageViewAggregationData>
    >(path);
    return obj.body.map(data => this.mapper.map(data));
  }

  private generateQuery(options: {
    storyId?: number;
    from?: Date | undefined;
    to?: Date | undefined;
  }) {
    const ary = [];
    if (options.storyId) {
      ary.push(`story_id=${options.storyId}`);
    }
    if (options.from) {
      ary.push(`from=${dateformat(options.from, 'yyyy.mm.dd')}`);
    }
    if (options.to) {
      ary.push(`to=${dateformat(options.to, 'yyyy.mm.dd')}`);
    }
    if (ary.length > 0) {
      return `?${ary.join('&')}`;
    } else {
      return '';
    }
  }
}
